import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-startup-posts',
  templateUrl: './startup-posts.component.html',
  styleUrls: ['./startup-posts.component.scss']
})
export class StartupPostsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
